import { NATIONAL_SCOPE } from './constantes'

export function isAvailableForPartner(partnerFilter: string[] = [], isAuthenticated: boolean, partnerId?: number) {
  return (
    (!isAuthenticated && partnerFilter.includes(NATIONAL_SCOPE)) ||
    (isAuthenticated && partnerId && partnerFilter.includes(`${partnerId}`))
  )
}
